import { Component, OnInit, Input } from '@angular/core';
import { NotificationData } from '../../providers/notification';
import { Store } from '@ngrx/store';
import { ENV } from '@app/env';
import { Observable } from 'rxjs/Observable';
import { ToastController } from 'ionic-angular';
import {
  map,
  switchMap,
  retryWhen,
  delay,
  tap,
} from 'rxjs/operators';
import { isEmpty } from 'lodash';
import { AngularFireAuth } from 'angularfire2/auth';
import { UtilitiesProvider } from '../../providers/utilities';

import firebase from 'firebase';
import { TranslateCodePipe } from '../../pipes/translate';
import { of } from 'rxjs/observable/of';

@Component({
  selector: 'enable-notifications',
  templateUrl: 'enable-notifications.html'
})
export class EnableNotificationsComponent implements OnInit {
  public showNotificationPopUp: boolean = false;

  public clientId: string;

  public firebaseMessaging = firebase.messaging();

  constructor(
    public notificationData: NotificationData,
    public store: Store<{}>,
    private afAuth: AngularFireAuth,
    private utilities: UtilitiesProvider,
    private toastCtrl: ToastController,
    private translatePipe: TranslateCodePipe
  ) { }

  ngOnInit() {
    if (ENV.mode === 'Production' && 'serviceWorker' in navigator) {
      this.utilities.consoleLogAll('Inicializando SW');
      this.initialize();
    }
  }

  public initialize() {
    this.getCurrentUser()
      .pipe(
        switchMap(currenUser => {
          this.utilities.consoleDecorator('currenUser', currenUser);
          if (currenUser) {
            return this.verifyAndAssignRegistration().pipe(
              map(registration => {
                if (this.notificationData.canShowNotificationPopUp()) {
                  this.showNotificationPopUp = true;
                } else if (this.notificationData.canShowNotificationPopUp() === null) {
                  this.notificationData
                    .userGetBrowserToken()
                    .subscribe(data => {
                      if (!isEmpty(data)) {
                        this.utilities.consoleLogAll('token', data);
                        this.utilities.consoleDecorator(
                          'Checkin token and review on firestore',
                          data
                        );
                      }
                    });
                }

              })
            );
          } else {
            this.showNotificationPopUp = false;
            return Observable.of({});
          }
        })
      )
      .subscribe(data => {
        if (!isEmpty(data)) {
          this.utilities.consoleDecorator('Initialize Notifications', data);
        }
      });
  }

  public verifyAndAssignRegistration() {
    return of({}).pipe(
      switchMap(none => this.verifySWRegistration()),
      switchMap(result => {
        this.utilities.consoleLogAll('REGISTRATION', result);
        if (!result) {
          throw new Error(result);
        }
        this.assignRegistrationToFCM(result);
        return Observable.of(result);
      }),
      retryWhen(errors => {
        return errors.pipe(
          tap(val => this.utilities.consoleErrorAll(`SW is: ${val} !`)),
          delay(1000)
        );
      }),
    );
  }

  public getCurrentUser(): Observable<any> {
    return this.afAuth.authState;
  }

  /**
   * Verify if the application has an active SW
   */
  public verifySWRegistration(): Observable<any> {
    return Observable.fromPromise(navigator.serviceWorker.getRegistration());
  }

  /**
   * Assign SW Registration to FCM
   */
  public assignRegistrationToFCM(reg): void {
    this.firebaseMessaging.useServiceWorker(reg);
  }

  public showNotification() {
    this.showNotificationPopUp = true;
  }

  public sendBrowserNotificationPopUp(option: 'Yes' | 'No') {
    this.showNotificationPopUp = false;
    switch (option) {
      case 'Yes':
        this.notificationData.userRequestPermission().subscribe(async () => {
          // If the user has must accept the notifications - Action only once
          if (this.notificationData.canShowNotificationPopUp() === null) {
            this.toastCtrl.create({
              message: await this.translatePipe.transform('Awesome ! You will receive real time notifications'),
              duration: 3000
            }).present();
          }
          this.utilities.consoleDecorator(
            'RequestPermission Detect change on token',
            ''
          );
        });
        return this.utilities.consoleDecorator(
          'User allow want to recieve push notifications',
          ''
        );
      case 'No':
        return this.utilities.consoleError(
          'User denied want to recieve push notifications',
          ''
        );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/enable-notifications/enable-notifications.ts